/* ======= SEZIONE MENU ======= */

// SETTINGS
export const MENU_DASHBOARD             = "MENU_DASHBOARD"             ;
export const MENU_SETTINGS              = "MENU_SETTINGS"              ;
export const MENU_COMPANY               = "MENU_COMPANY"               ;
export const MENU_SITES                 = "MENU_SITES"                 ;
export const MENU_USERS                 = "MENU_USERS"                 ;
export const MENU_WORKFLOW              = "MENU_WORKFLOW"              ;
export const MENU_DEPOSITS              = "MENU_DEPOSITS"              ;
export const MENU_PAYMENTS              = "MENU_PAYMENTS"              ;
export const MENU_DISCOUNTS             = "MENU_DISCOUNTS"             ;
export const MENU_RATE                  = "MENU_RATE"                  ;
export const MENU_ARCHIVES              = "MENU_ARCHIVES"              ;
export const MENU_ACCOUNTS              = "MENU_ACCOUNTS"              ;
// export const MENU_CUSTOMERS             = "MENU_CUSTOMERS"             ;
export const MENU_SUBCONTRACTOR         = "MENU_SUBCONTRACTOR"         ;
// export const MENU_SUPPLIERS             = "MENU_SUPPLIERS"             ;
export const MENU_ITEMS                 = "MENU_ITEMS"                 ;
export const MENU_ITEM_CATEGORIES                 = "MENU_ITEM_CATEGORIES"                 ;
export const MENU_NAME_LIST             = "MENU_NAME_LIST"             ;
export const MENU_ITEM_PURPOSES         = "MENU_ITEM_PURPOSES"         ;
export const MENU_PRECONF_ITEMS         = "MENU_PRECONF_ITEMS"         ;
export const MENU_PRICE_LISTS           = "MENU_PRICE_LISTS"           ;
export const MENU_PRECONF_CUSTOMER_LIST = "MENU_PRECONF_CUSTOMER_LIST" ;
export const MENU_PROJECT               = "MENU_PROJECT"               ;
export const MENU_PROJECT_CATEGORY      = "MENU_PROJECT_CATEGORY"      ;
export const MENU_PROJECT_TYPE          = "MENU_PROJECT_TYPE"          ;
export const MENU_ORDERS                = "MENU_ORDERS"                ;
export const MENU_ORDER_TYPES           = "MENU_ORDER_TYPES"           ;
export const MENU_RECEIVABLES           = "MENU_RECEIVABLES"           ;
export const MENU_QUOTES                = "MENU_QUOTES"                ;
export const MENU_BOM                   = "MENU_BOM"                   ;
export const MENU_SAL                   = "MENU_SAL"                   ;
export const MENU_NUMBERING_ORDERS      = "MENU_NUMBERING_ORDERS"      ;
export const MENU_ADVANCE_PAYMENTS      = "MENU_ADVANCE_PAYMENTS"       ;
export const MENU_CUSTOMER_ORDERS       = "MENU_CUSTOMER_ORDERS"       ;
export const MENU_CUSTOMER_INVOICE       = "MENU_CUST_INVOICE"       ;
export const MENU_BOMS       = "MENU_BOMS"       ;
export const MENU_SUPPLIER_ORDERS       = "MENU_SUPPLIER_ORDERS"       ;
export const MENU_WAREHOUSE             = "MENU_WAREHOUSE"             ;
export const MENU_INVENTORY_MOVEMENT    = "MENU_INVENTORY_MOVEMENT"    ;
export const MENU_BANKS                 = "MENU_BANKS"                 ;

/* GENERIC */
export const CREATE = "create";
export const EDIT = "edit";
export const VIEW = "view";
export const DELETE = "delete";
export const TOGGLE = "toggle";

/* SEZIONE UTENTI */
export const CREATE_USER = "create";

/* SEZIONE SUBAPPALTATORI */
export const CREATE_SUBCONTRACTOR = "create";

/* SEZIONE WORKFLOW */
export const CREATE_WORKFLOW = "create";

/* SEZIONE PROJECT_TYPE */
export const CREATE_PROJECT_TYPE = "create";

/* SEZIONE PROJECT_CATEGORY */
export const CREATE_PROJECT_CATEGORY = "create";

/* SEZIONE PROGETTO */
export const CREATE_PROJECT = "create";
export const VIEW_WORKFLOW_TAB = "viewWorkflow";
export const VIEW_REMINDER_TAB = "viewReminder";
export const VIEW_SPECIFICATIONS_INFO_TAB = "viewSpecificationsInfo";
export const EDIT_SPECIFICATIONS_INFO_TAB = "editSpecificationsInfo";
export const VIEW_SECURITY_TAB = "viewSecurity";
export const EDIT_SECURITY_TAB = "editSecurity";
export const VIEW_ASSOCIATED_USERS_TAB = "viewAssociatedUsers";
export const EDIT_ASSOCIATED_USERS_TAB = "editAssociatedUsers";
export const VIEW_DOCUMENTS_WORKFLOW_TAB = "viewDocumentsWorkflow";
export const VIEW_DOCUMENTS_SECURITY_TAB = "viewDocumentsSecurity";

/* SEZIONE NOMINATIVI */
export const VIEW_FISCAL_INFO = "viewFiscalInfo";